const $$splitComponentImporter = () => import('/app/src/routes/meetings.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/meetings")({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});